module.exports = __webpack_public_path__ + "static/media/help_support.b7d04bb9.svg";